import React from 'react';
import './App.css';
import 'materialize-css';
import {BrowserRouter as Router, Route, Link, Switch, Redirect} from "react-router-dom";
import Cookies from "universal-cookie/es6";


import Firebase from "firebase";

import MainNavbar from "./components/Header";
import MainCrypt from "./MainCrypt";
import MainFooter from "./components/Footer";
import MainHardCrypt from "./MainHardCrypt";
import MainDESCrypt from "./MainDESCrypt";
import MainAESCrypt from "./MainAESCrypt";
import MainMD5Hash from "./MainMD5Hash";
import MyAccount from "./myAccount";
import CryptoFunction from "./functions/CryptoFunctions";
import AuthFromVK from "./components/AuthFromVK";
import Login from "./Login";


const cookie = new Cookies();

const firebaseConfig = {
    apiKey: "AIzaSyBNuKwWFQehwVyl3w7Pym_2Aa7pm_j1Jqw",
    authDomain: "hashtohash-1eead.firebaseapp.com",
    databaseURL: "https://hashtohash-1eead.firebaseio.com",
    projectId: "hashtohash-1eead",
    storageBucket: "hashtohash-1eead.appspot.com",
    messagingSenderId: "882112226305",
    appId: "1:882112226305:web:73f9b240b230dd585a8c00"
};
Firebase.initializeApp(firebaseConfig);

class  App extends React.Component{

    constructor(props) {
        super(props);

        this.state = {
            auth: cookie.get('_VKAuth') !== undefined,
            // session: null,
            key: null,
            redirFromAuth: false,
        }

    }


    handleVkResponse = (data) => {
        console.warn(data);
        if (data.status === 'connected') {


            cookie.set('_VKAuth', data.session.sid, { path: '/', expires: new Date(Date.now() + 2678400000)});
            cookie.set('_VKAuthMID', data.session.user.id, { path: '/', expires: new Date(Date.now() + 2678400000)});

            Firebase.firestore().collection('accounts')
                .where('mid', '==', data.session.user.id)
                .get()
                .then((el)=>{
                    if (el.docs.length === 0) {
                        Firebase.firestore().collection('accounts')
                            .add({mid: data.session.user.id, mKey: null})
                    }
                })

            this.setState({
                auth: true,
                redirFromAuth: true
            })
        }
    }

    exitFromVK = ()=>{
        cookie.remove('_VKAuth', { path: '/' });
        cookie.remove('_VKAuthMID', { path: '/' });
        this.setState({
            auth: false,
            // session: null,
            key: null
        });

    }

    render () {

        return (
            <Router>
                <Route render={({location})=>(
                    <React.Fragment>
                        {this.state.redirFromAuth ? <Redirect to={'/myAccount/'} /> : null}
                        <MainNavbar callback={this.handleVkResponse} auth={this.state.auth}/>

                        <Switch location={location}>
                            <Route path='/' exact>
                                <MainCrypt auth={this.state.auth}/>
                            </Route>
                            <Route path='/hard/' exact>
                                <MainHardCrypt auth={this.state.auth}/>
                            </Route>
                            <Route path='/des/' exact>
                                <MainDESCrypt auth={this.state.auth} />
                            </Route>
                            <Route path='/aes/'  exact>
                                <MainAESCrypt auth={this.state.auth}/>
                            </Route>
                            <Route path='/md5/' exact component={MainMD5Hash}/>
                            <Route path='/myAccount/' exact>
                                <MyAccount exit={this.exitFromVK} auth={this.state.auth}/>
                            </Route>
                            <Route path='/login/' exact>
                                <Login callback={this.handleVkResponse} auth={this.state.auth}/>
                            </Route>
                        </Switch>

                        <MainFooter />
                    </React.Fragment>
                )}/>
            </Router>
        );
    }
}

export default App;
